import { InfoM } from '@app/modules/audit/modules/aod/screens/aod-rule-view/components/InfoM';
import { auditReports } from '@mi-front/api-clients';
import { Seconds } from '@mi-front/core';
import { Duration, QueryView } from '@mi-front/ui';
import { Box, Grid, Stack, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useEvidenceExportPathFormats } from './useEvidenceExportPathFormats';

export const GipExportConfigInfo = ({
  config,
  inDialog,
}: {
  inDialog?: boolean;
  config: auditReports.GipEvidenceExportOptionsDto;
}) => {
  const pathFormats = useEvidenceExportPathFormats() ?? [];
  const definitionId = config.definitionId;
  const definitionQuery = auditReports.useGetReportDefinitionById(definitionId || '', {
    query: {
      enabled: !!definitionId,
    },
  });

  return (
    <Stack>
      <Grid container spacing={2}>
        <Grid item xl={inDialog ? undefined : 3} lg={inDialog ? undefined : 4} md={6}>
          <Typography variant="subtitle1" sx={{ mb: 3 }}>
            <FormattedMessage
              id="audit.gipReport.export.filesConfig"
              defaultMessage="Configuración de archivos"
            />
          </Typography>

          <Box mt={3}>
            <InfoM
              label={
                <FormattedMessage
                  id="audit.gipReport.export.audioMatchIncludeBeforeLabel"
                  defaultMessage="Segundos a incluir antes del match"
                />
              }
            >
              <Duration seconds={config.audioMatchIncludeBefore as Seconds} />
            </InfoM>
            <InfoM
              label={
                <FormattedMessage
                  id="audit.gipReport.export.audioMatchIncludeAfterLabel"
                  defaultMessage="Segundos a incluir después del match"
                />
              }
            >
              <Duration seconds={config.audioMatchIncludeAfter as Seconds} />
            </InfoM>
            {config.pathFormat?.formatId && (
              <InfoM
                label={
                  <FormattedMessage
                    id="audit.gipReport.export.pathFormat"
                    defaultMessage="Formato de path"
                  />
                }
              >
                {pathFormats.find((f) => f.id === config.pathFormat!.formatId)?.label}
              </InfoM>
            )}
            {config.pathFormat?.formatCustomText && (
              <InfoM
                label={
                  <FormattedMessage
                    id="audit.gipReport.export.customTextInPath"
                    defaultMessage="Texto custom en path"
                  />
                }
              >
                {config.pathFormat.formatCustomText}
              </InfoM>
            )}
          </Box>
        </Grid>
        <Grid item xl={inDialog ? undefined : 3} lg={inDialog ? undefined : 4} md={6}>
          <Typography variant="subtitle1" sx={{ mb: 3 }}>
            <FormattedMessage
              id="audit.gipReport.export.xlsConfig"
              defaultMessage="Configuración de XLS"
            />
          </Typography>

          {definitionId ? (
            <QueryView query={definitionQuery} inline>
              {(definition) => (
                <InfoM
                  label={
                    <FormattedMessage
                      id="audit.gipReport.export.definition"
                      defaultMessage="Plantilla"
                    />
                  }
                >
                  {definition.name}
                </InfoM>
              )}
            </QueryView>
          ) : (
            <>
              {typeof config.excludeVersion !== 'undefined' && (
                <InfoM
                  label={
                    <FormattedMessage
                      id="audit.gipReport.export.excludeVersion"
                      defaultMessage="Excluir versión"
                    />
                  }
                >
                  {config.excludeVersion ? (
                    <FormattedMessage id="common.yes" defaultMessage="Sí" />
                  ) : (
                    <FormattedMessage id="common.no" defaultMessage="No" />
                  )}
                </InfoM>
              )}
              {typeof config.publicLink !== 'undefined' && (
                <InfoM
                  label={
                    <FormattedMessage
                      id="audit.gipReport.export.publicLink"
                      defaultMessage="Incluir link público"
                    />
                  }
                >
                  {config.publicLink ? (
                    <FormattedMessage id="common.yes" defaultMessage="Sí" />
                  ) : (
                    <FormattedMessage id="common.no" defaultMessage="No" />
                  )}
                </InfoM>
              )}
            </>
          )}
        </Grid>
      </Grid>
    </Stack>
  );
};
